import Map from 'ol/map';
import Feature from 'ol/feature';
import View from 'ol/view';
import Point from 'ol/geom/point';
import Vector from 'ol/source/vector';
import OSM from 'ol/source/osm';
import Stamen from 'ol/source/stamen';
import proj from "ol/proj";
import Style from "ol/style/style";
import Icon from "ol/style/icon";
import VectorLayer from "ol/layer/vector";
import TileLayer from "ol/layer/tile";
import control from 'ol/control';

export const createMap = (selector, featureGroups = [], greyscale = false, zoom = 17) => {
    const centerCoords = proj.transform(featureGroups[0]?.locations[0] ?? [0,0], 'EPSG:4326', 'EPSG:3857');
    const layers = featureGroups.map((group) => {
        const style = new Style({
            image: new Icon({
                src: group.icon
            })
        });
        const features = group.locations.map(location => new Feature({
            geometry: new Point(proj.transform(location, 'EPSG:4326', 'EPSG:3857'))
        }));
        const source = new Vector({ features });
        return new VectorLayer({ source, style })
    });

    if (greyscale) {
        layers.unshift(new TileLayer({
            source: new Stamen({ layer: 'toner' })
        }));
    } else {
        layers.unshift(new TileLayer({
            source: new OSM()
        }));
    }

    const map = new Map({
        layers,
        target: selector,
        controls: control.defaults({
            attributionOptions: ({
                collapsible: false
            })
        }),
        view: new View({
            center: centerCoords,
            zoom: zoom ?? 17,
            maxZoom: 19
        })
    });

    if(document.getElementById('ol-zoom-out') !== null){
        document.getElementById('ol-zoom-out').onclick = function() {
            let view = map.getView();
            let zoom = view.getZoom();
            view.setZoom(zoom - 1);
        };
    }
    if(document.getElementById('ol-zoom-in') !== null){
        document.getElementById('ol-zoom-in').onclick = function() {
            let view = map.getView();
            let zoom = view.getZoom();
            view.setZoom(zoom + 1);
        };
    }

}